<div class="screen-header qnHeadingContainer" id="divHeadingContainer">
    <h1 id="h1PrimaryHeader" class="question primary-header" [innerHtml]="QnSubDescription" [ngClass]="{'desktop-header-size': isDesktop,
    'tablet-header-size': isTablet,
    'mobile-header-size': isMobile}"></h1>
    <div class="secondary-header" [innerHtml]="QnDescription" id="divSecondaryHeader"></div>
</div>
